import { useNavigate } from '@tanstack/react-router';
import { Eye } from 'lucide-react';

import { usePreviewStore } from '@/stores/previewStore';
import { useUiStore } from '@/stores/uiStore';

interface Props {
  batchId: string;
  batchName?: string;
  /** When given, preview deep-links to this topic's student lesson page. */
  topicId?: string;
  className?: string;
}

export function PreviewAsStudentButton({ batchId, batchName, topicId, className }: Props) {
  const navigate = useNavigate();
  const enterPreview = usePreviewStore((s) => s.enterPreview);
  const setCurrentBatchId = useUiStore((s) => s.setCurrentBatchId);

  const handleClick = () => {
    enterPreview({ batchId, batchName, returnTo: window.location.pathname });
    // Point the student shell (batch switcher, dashboard) at this batch.
    setCurrentBatchId(batchId);
    navigate({ to: topicId ? `/courses/${batchId}/topics/${topicId}` : `/courses/${batchId}` });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ??
        'inline-flex items-center gap-1.5 rounded-md border border-border bg-background px-2.5 py-1.5 text-xs font-medium hover:bg-muted'
      }
    >
      <Eye className="h-3.5 w-3.5" />
      Preview as student
    </button>
  );
}
